/* eslint-disable lines-between-class-members */
import MicrophoneError from '@src/logic/errors/microphoneError';
import { createSession } from '../callSession';
import CallMediaBridge from './CallMediaBridge';

class CallMedia {
  static instance: CallMedia;

  private bridge = new CallMediaBridge();
  private localStream: MediaStream | null = null;

  async connect() {
    const session = await createSession();
    const handle = await this.bridge.connect(session);

    return { handleId: handle?.getId(), sessionId: session.getSessionId() };
  }

  async joinRoom(roomId: number) {
    // A stream left by an earlier attempt would keep the microphone captured.
    await this.cleanup();
    try {
      this.localStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
    } catch (error) {
      throw new MicrophoneError();
    }

    this.bridge.send({ request: 'create', room: roomId, is_private: false });
    this.bridge.send({ request: 'join', room: roomId });
    await this.bridge.startAudio(this.localStream);
  }

  async leaveRoom() {
    this.bridge?.send({ request: 'leave' });

    // Disconnect (detach Janus handle + close RTCPeerConnection) before stopping
    // local tracks. Safari does not release the mic indicator if track.stop() is
    // called while the track is still attached to an active PeerConnection.
    this.bridge.disconnect();

    await this.cleanup();
  }

  mute() {
    this.bridge?.send({ request: 'configure', muted: true });
    this.localStream?.getAudioTracks().forEach(t => {
      t.enabled = false;
    });
  }

  unmute() {
    this.bridge?.send({ request: 'configure', muted: false });
    this.localStream?.getAudioTracks().forEach(t => {
      t.enabled = true;
    });
  }

  async cleanup() {
    if (this.localStream) {
      const tracks = [...this.localStream.getTracks()];

      tracks.forEach(track => {
        if (track.readyState === 'live') {
          track.stop();
          track.enabled = false;
        }
      });

      await new Promise(resolve => setTimeout(resolve, 100));

      this.localStream = null;
    }
  }

  async disconnect() {
    this.bridge.disconnect();
    // return { handle: handle?.getId(), sessionId: session.getSessionId() };
  }

  static getInstance() {
    if (!CallMedia.instance) {
      CallMedia.instance = new CallMedia();
    }

    return CallMedia.instance;
  }
}

export default CallMedia;
